module.exports = __webpack_public_path__ + "img/22.c72bf53a.png";